var $718705a15b8a633a$exports = {};
$718705a15b8a633a$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`,
    "colorSwatchPicker": `Color swatches`
};


export {$718705a15b8a633a$exports as default};
//# sourceMappingURL=et-EE.mjs.map
